import { render, staticRenderFns } from "./ChannelCard.vue?vue&type=template&id=3c6eec4e"
import script from "./ChannelCard.vue?vue&type=script&lang=ts"
export * from "./ChannelCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports